import { Routes } from '@angular/router';

import { ForgotPasswordPageComponent } from './containers/forgot-password-page.component';
import { ResetPasswordPageComponent } from './containers/reset-password-page.component';
import { WaitPasswordPageComponent } from './containers/wait-password-page.component';
import { ConfirmPasswordPageComponent } from './containers/confirm-password-page.component';
import { HasForgotPasswordGuard } from './guards/has-forgot-password.guard';
import { HasCodeGuard } from './guards/has-code.guard';

export const routesForgotPassword: Routes = [
  {path: 'forgot', component: ForgotPasswordPageComponent},
  {path: 'reset', component: ResetPasswordPageComponent, canActivate: [HasCodeGuard]},
  {path: 'wait', component: WaitPasswordPageComponent, canActivate: [HasForgotPasswordGuard]},
  {path: 'confirm', component: ConfirmPasswordPageComponent},
];




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/forgot-password.routes.ts